
import {
  HubspotFieldNames
} from '@/constants/hubspot';
import { FormikProps } from 'formik';
import { FC } from 'react';
import { ButtonElement } from '../Button';
import { Text } from '../Text';
import { default as ConfirmationCodeField } from './ConfirmationCodeField';
import TrialFullScreenLoader from './TrialFullScreenLoader';
import { TrialFormStepFields } from './TrialPersonalInfoForm';

type ConfirmationCodeFormProps = {
  formik: FormikProps<TrialFormStepFields & { code: string, password: string }>;
  showLoader: boolean;
  error: string;
}

const ConfirmationCodeForm: FC<ConfirmationCodeFormProps> = ({ formik, showLoader, error }) => {

  return (
    <>
      <form onSubmit={formik.handleSubmit} noValidate className="flex flex-col pt-xs space-y-xl">
        <div className="flex">
          <ConfirmationCodeField
            code={formik.values.code}
            confirmationCodeLength={6}
            onChange={(value) => formik.setFieldValue('code', value)}
            disabled={false}
            invalid={formik.touched.code && !!formik.errors.code}
            onFocus={() => {
              if (formik.errors.code?.includes('Incorrect')) {
                formik.setFieldValue('code', '');
              }
            }}
          />
        </div>
        {formik.touched.code && !!formik.errors.code ? <p>{formik.errors.code}</p> : null}

        {!!error ? <Text as="span" type="caption1" className="text-red-500">
          {error}
        </Text> : null}

        <ButtonElement
          variant="primary"
          buttonType="filled"
          disabled={formik.isValidating || formik.isSubmitting}
          text={formik.isSubmitting ? 'Creating your account...' : 'Create my account'}
        />
      </form>

      {showLoader ? (
        <TrialFullScreenLoader firstName={formik.values[HubspotFieldNames.FirstName]} industry={formik.values[HubspotFieldNames.Industry]} />
      ) : null}
    </>
  );
};

export default ConfirmationCodeForm;
